import React from "react";
import { Box } from "@mui/material";

/** a simple house drawing */
const HouseIllustration: React.FC<{ width?: number }> = ({ width = 76 }) => (
  <Box component="svg" viewBox="0 0 120 100" sx={{ width, height: width * 0.84, flexShrink: 0 }} aria-hidden>
    <ellipse cx="60" cy="94" rx="52" ry="5" fill="#e0e0e0" />
    <rect x="22" y="44" width="76" height="50" rx="3" fill="#fff3e0" stroke="#8d6e63" strokeWidth="2.5" />
    <path d="M12 48 L60 10 L108 48" fill="#ef6c00" stroke="#bf360c" strokeWidth="3" strokeLinejoin="round" />
    <rect x="80" y="18" width="10" height="20" fill="#8d6e63" />
    <rect x="50" y="64" width="20" height="30" rx="2" fill="#8d6e63" />
    <circle cx="65" cy="80" r="1.6" fill="#fff3e0" />
    <rect x="30" y="56" width="14" height="14" rx="1.5" fill="#bbdefb" stroke="#8d6e63" strokeWidth="2" />
    <rect x="76" y="56" width="14" height="14" rx="1.5" fill="#bbdefb" stroke="#8d6e63" strokeWidth="2" />
    <path d="M37 56 V70 M30 63 H44 M83 56 V70 M76 63 H90" stroke="#8d6e63" strokeWidth="1.2" />
  </Box>
);

export default HouseIllustration;
